import appConfig from '@/config/appConfig.typed';

import {areSsoCookiesMissing} from './ssoCookieService';

export type IccLoginTokenListSessionInfoProps = {
    isDcxMarket: boolean;
    /**
     * false when SessionInfo must not be requested (e.g. `openInBluefy`, or a debounced batch
     * where every queued item is Bluefy-only — see `batchAllowSsoCookies` in useSsoLinkBatch).
     */
    allowSessionInfo: boolean;
    /**
     * Timestamp of the last successful cookie application (`recordSsoSessionApplied()`).
     * `null` means we don't know the cookie age yet (e.g. after a page reload).
     */
    lastSsoSessionApplyAt: number | null;
};

/**
 * Whether `CreateLoginTokenList` / `getSsoLinks` should send `IncludeSessionInfo: true`.
 */
export const shouldRequestIccLoginTokenListSessionInfo = (props: IccLoginTokenListSessionInfoProps): boolean => {
    const cookiesMissingOrUnknownTimestamp = areSsoCookiesMissing() || props.lastSsoSessionApplyAt == null;

    const result =
        Boolean(appConfig.getIsSsoCookiesEnabled()) &&
        props.isDcxMarket &&
        props.allowSessionInfo &&
        cookiesMissingOrUnknownTimestamp;

    return result;
};

/**
 * Whether SSO cookie refresh / cookie-oriented batch behaviour applies (config + DCX + not Bluefy).
 * Does not depend on current cookie presence — used for scheduling and hook `disabled` flags.
 */
export const isSsoCookiesFlowActive = (props: {isDcxMarket: boolean; openInBluefy?: boolean}): boolean =>
    Boolean(appConfig.getIsSsoCookiesEnabled()) && props.isDcxMarket && !props.openInBluefy;
